<app-desktop-view *ngIf="!isMobileView"></app-desktop-view>
<app-mobile-view *ngIf="isMobileView" ></app-mobile-view>
